import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Link } from "react-router";
import styled from "styled-components";
import ManualDownloadLink from "./ManualDownloadLink";
import { useEffect } from "react";

const StyledLink = styled(Link)`
  text-decoration: none;
  & :hover {
    text-decoration: underline;
  }
`;

const Complete = ({ step1Download }) => {
  useEffect(() => { document.title = "Podium Prepper - Complete" }, []);

  return (
    <div style={{ textAlign: "center" }}>
      <CheckCircleIcon sx={{ color: "#7a9c49", fontSize: 90 }} />
      <h2>Processing Complete!</h2>
      <ManualDownloadLink download={step1Download} />
      <br />
      <StyledLink to="/step1">Return to start page</StyledLink>
    </div>
  );
};

export default Complete;
